import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"

export type UtmList = {
  utm_campaign: null | string
  utm_content: null | string
  utm_medium: null | string
  utm_source: null | string
  utm_term: null | string
}

const COOKIES_NAME = "utm_list"
export const useUserUtm = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [utm, setUtm] = useState<UtmList | null>(null)

  const removeQuery = (queryLIst: string[]) => {
    const newParams = new URLSearchParams(searchParams) // Создаем новый объект
    queryLIst.forEach((param) => newParams.delete(param)) // Удаляем параметры
    setSearchParams(newParams, { replace: true }) // Обновляем URL
  }

  useEffect(() => {
    const utmList = {
      utm_campaign: searchParams.get("utm_campaign"),
      utm_content: searchParams.get("utm_content"),
      utm_medium: searchParams.get("utm_medium"),
      utm_source: searchParams.get("utm_source"),
      utm_term: searchParams.get("utm_term"),
    }

    const isEmpty = isEmptyLIst(utmList)

    if (!isEmpty) {
      setUtm(utmList)
      saveCached(utmList)
      removeQuery(Object.keys(utmList))
    } else {
      const cached = getCached()

      if (cached) {
        setUtm(cached)
      }
    }
  }, [])

  const isEmptyLIst = (utm: UtmList): boolean => {
    return Object.values(utm).some((u) => u === null)
  }

  const saveCached = (value: UtmList, days = 2) => {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000) // Добавляем 2 дня
    const expires = `expires=${date.toUTCString()}`
    document.cookie = `${COOKIES_NAME}=${JSON.stringify(value)}; ${expires}; path=/`
  }

  function getCached(): UtmList | null {
    const cookies = document.cookie.split("; ")

    for (let cookie of cookies) {
      const [key, value] = cookie.split("=")
      if (key === COOKIES_NAME)
        return value ? (JSON.parse(value) as UtmList) : null
    }

    return null
  }

  return {
    utm,
  }
}
